import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zdxcxuak9e: FaireBrandEntity = {
  token: "b_zdxcxuak9e",
  type: "brand",
  name: "Nova Toys LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/281485d02f6143ea16e988f21be9bf451d3129063ffed723e25d20fdc997a962.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/033bf245520baaeebc9b12369696b950971fda4f6526d72054784d2a1bb92541.png",
  logoUrl:
    "https://cdn.faire.com/fastly/281485d02f6143ea16e988f21be9bf451d3129063ffed723e25d20fdc997a962.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/033bf245520baaeebc9b12369696b950971fda4f6526d72054784d2a1bb92541.png",
  location: "Millersburg, PA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 6,
  isTopShop: true,
  isInsider: true,
  description:
    "Nova Toys is your premier destination for quality toy brands in the retail and educational markets. As a trusted distributor, we are committed to providing exceptional play experiences for children of all ages. From classic favorites to innovative new products, Nova Toys curates a diverse selection of toys that inspire creativity, spark imagination, and promote learning. Whether you're a retailer looking to enhance your product offerings an educator seeking engaging resources for your classroom or a parent that wishes to spend some playtime with his child, Nova Toys has something special for everyone. Explore our catalog and discover the magic of play with Nova Toys today. \n\nWe are proud to be active members of ASTRA (American Specialty Toy Retailing Association) and MSA (Museum Store Association), two esteemed organizations dedicated to promoting excellence and innovation within our industry.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:46.897Z",
    importedBy: "entity-db-cli",
  },
};
